/**
 * AdminCustomersRpcClient - AtomRpc integration for admin customer endpoints
 *
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { CustomersRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminCustomersRpcClient extends AtomRpc.Tag<AdminCustomersRpcClient>()(
  "AdminCustomersRpcClient",
  {
    group: CustomersRpcs,
    protocol: makeRpcClientLayer(CustomersRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
